import { render } from "./Rocket.vue?vue&type=template&id=254ae8fe"
import script from "./Rocket.vue?vue&type=script&lang=js"
export * from "./Rocket.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__